import axios from 'axios';
import i18next from 'i18next';

import {requestHelper} from "./request.helper";
import {reTokenizerHelper} from "./reTokenizeModule/reTokenizer.helper";
import {userService} from "../_services";
import {store} from "./store"
import {notificationConstants} from "../_constants";
import {alertActions} from "../_actions";

/**
 * Export axios instance with configured baseURL
 * @type {AxiosInstance} axios instance
 */
export const gistApi = axios.create({
    baseURL: requestHelper.getBaseUrl(),
    /* other custom settings */
});

/**
 * Intercepts all responses and
 * if 401 Unauthorized is encountered
 * 1. (due to access token expiration) then tries to refresh the access tokens
 * 2. (due to refresh token expiration) then redirect user to log in page
 */
gistApi.interceptors.response.use(
    function(response) {
        // if the request succeeds, then return it
        return response;
    },
    function(error) {
        const errorResponse = error.response;
        const userTokens = userService.getAuthUser();
    
        /*
         * 1. if the error is due to refresh token expiration, then redirect to login
         * 2. if the error is due to access token expiration, then try to re-tokenize
         */
        if (errorResponse && reTokenizerHelper.isRefreshTokenExpired(errorResponse, userTokens)) {
            const t = i18next.t;
    
            const message = {
                "errorMsg": t("Your session has expired. Please login again."),
                "redirectParams": {
                    "redirectTo": "/signin"
                },
                "toastParams": {
                    "toastType": notificationConstants.NOTIFICATION_TYPES.ERROR,
                },
            }
            store.dispatch(alertActions.error(message));
        } else if (errorResponse && reTokenizerHelper.isTokenRefreshable(errorResponse, userTokens)) {
            return reTokenizerHelper.refreshTokenAndReattempt(error)
        }

        // if the error does not relate to access token expiration, then just proceed with the error
        return Promise.reject(error)
    }
);
